module.exports = __webpack_public_path__ + "media/images/layout/logo-269cbb77c94a052558884ba0905fd054.svg";